module.exports = __webpack_public_path__ + "public/images/schedule/bel-table.5fe1ab21c5cc952ad160e91c82200157.png";